var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSpecialChevronDown = function SvgSpecialChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 8",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.076 2.617A1 1 0 012 2h4a1 1 0 01.707 1.707l-2 2a1 1 0 01-1.414 0l-2-2a1 1 0 01-.217-1.09z",
    fill: "#48525C"
  })));
};
export default SvgSpecialChevronDown;